export const BuyGetFreeHelper = {
  getRangeProductBucket(productType) {
    return productType === 'SERVICE' ? 'SERVICE' : 'GOODS'
  },

  hasMixedRangeProductTypes(products = []) {
    const buckets = new Set(
      (products || [])
        .map((product) => product?.productType)
        .filter(Boolean)
        .map((productType) => this.getRangeProductBucket(productType))
    )

    return buckets.size > 1
  },

  isTierValid(tier, requiresFixedFreeProduct = true, maxFreeUnitsCap = null) {
    const withinCap =
      !maxFreeUnitsCap || Number(tier.freeQuantity) <= Number(maxFreeUnitsCap)

    return (
      tier.buyQuantity &&
      (!requiresFixedFreeProduct || tier.freeProduct) &&
      tier.freeQuantity &&
      tier.buyQuantity > 0 &&
      tier.freeQuantity > 0 &&
      withinCap
    )
  },

  hasValidNationalTiers(
    nationalTiers,
    isEdit = false,
    maxFreeUnitsCap = null,
    requiresFixedFreeProduct = true
  ) {
    if (nationalTiers.length === 0) return false

    const hasCap = !!maxFreeUnitsCap && Number(maxFreeUnitsCap) > 0

    return nationalTiers.every((tier) => {
      if (tier.isNew && !tier.isAdded && !isEdit && !hasCap) {
        return true
      }

      if (hasCap) {
        return this.isTierValid(tier, requiresFixedFreeProduct, maxFreeUnitsCap)
      }

      return this.isTierValid(tier, requiresFixedFreeProduct) && tier.isAdded
    })
  },

  hasValidStateTiers(
    stateTiers,
    isEdit = false,
    maxFreeUnitsCap = null,
    requiresFixedFreeProduct = true
  ) {
    const hasCap = !!maxFreeUnitsCap && Number(maxFreeUnitsCap) > 0

    const statesWithTiers = stateTiers.filter((state) =>
      state.tiers.some((tier) => tier.buyQuantity > 0 && tier.freeQuantity > 0)
    )
    if (statesWithTiers.length === 0) return false

    return statesWithTiers.every((state) => {
      return state.tiers.every((tier) => {
        if (tier.isNew && !tier.isAdded && !isEdit && !hasCap) {
          return true
        }

        if (hasCap) {
          return this.isTierValid(
            tier,
            requiresFixedFreeProduct,
            maxFreeUnitsCap
          )
        }

        return this.isTierValid(tier, requiresFixedFreeProduct) && tier.isAdded
      })
    })
  },

  hasUnsavedTiers(tiers, requiresFixedFreeProduct = true) {
    return tiers.some(
      (tier) => !this.isTierValid(tier, requiresFixedFreeProduct) || tier.isNew
    )
  },

  isTierDuplicate(tiers, tier) {
    return tiers.some(
      (existingTier) => existingTier.buyQuantity === tier.buyQuantity
    )
  },

  hasValidTier(
    nationalTiers,
    stateTiers,
    targetType,
    requiresFixedFreeProduct = true
  ) {
    if (targetType === 'NATIONAL') {
      return this.hasValidNationalTiers(
        nationalTiers,
        false,
        null,
        requiresFixedFreeProduct
      )
    }
    if (targetType === 'STATE') {
      return this.hasValidStateTiers(
        stateTiers,
        false,
        null,
        requiresFixedFreeProduct
      )
    }
    if (targetType === 'MULTI_STORE_OPERATOR') {
      return this.hasValidStateTiers(
        stateTiers,
        false,
        null,
        requiresFixedFreeProduct
      )
    }
    if (targetType === 'BANNER_GROUP') {
      return this.hasValidStateTiers(
        stateTiers,
        false,
        null,
        requiresFixedFreeProduct
      )
    }
    if (targetType === 'RETAILER_STORE') {
      return this.hasValidStateTiers(
        stateTiers,
        false,
        null,
        requiresFixedFreeProduct
      )
    }
    return false
  },

  validateMaxCap(nationalTiers, stateTiers, targetType, maxFreeUnitsCap) {
    if (!maxFreeUnitsCap || maxFreeUnitsCap <= 0) return true

    let allTiers = []
    if (targetType === 'NATIONAL') {
      allTiers = nationalTiers
    } else if (
      targetType === 'STATE' ||
      targetType === 'MULTI_STORE_OPERATOR' ||
      targetType === 'BANNER_GROUP' ||
      targetType === 'RETAILER_STORE'
    ) {
      allTiers = stateTiers.flatMap((s) => s.tiers)
    }

    return allTiers.every((tier) => {
      if (!tier.freeQuantity) return true
      return Number(tier.freeQuantity) <= Number(maxFreeUnitsCap)
    })
  }
}
